<template>
    <div class="piechart">
        <div class="text-xs-center">
            <h5>{{ title }}</h5>
        </div>
        <ve-pie :data="chartData" :toolbox="toolbox"></ve-pie>
    </div>
</template>

<script>
export default {
    props: {
        title: { type: String, required: false, default: null },
        cols: { type: Array, required: false, default: null },
        data: { type: Array, required: false, default: null }
    },
    data() {
        return {
            chartData: {
                columns: this.cols,
                rows: this.data
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title: "Salvar imagen"
                    }
                }
            }
        }
    }
}
</script>
